<template>
  <footer>
    <div class="top-footer">
      <b-container>
        <div class="top-newsletter">
          <b-row>
            <b-col sm="12" md="6">
              <p class="newsletter-text">Want to receive exclusive hotel offers? Subscribe to our newsletter!</p>
            </b-col>
            <b-col sm="12" md="6">
              <div class="newsletter-subscribe">
                <NewsletterSubscribe/>
              </div>
            </b-col>
          </b-row>
          <SocialIconList/>
        </div>
      </b-container>
      <b-container>
        <b-row>
          <b-col md="8">
            <div class="footer-address">
              <strong>Stay.com</strong>, Nieuwe Stationsstraat 20, 6811 KS Arnhem, The Netherlands
            </div>
            <div class="footer-social">

            </div>
          </b-col>
          <b-col>
            <!-- language switcher -->
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" lg="3">
            <h5>Social</h5>
            <ul class="footer-list">
              <li><a href="https://www.facebook.com/staydcom" target="_blank">Facebook</a></li>
              <li><a href="https://www.instagram.com/staydcom" target="_blank">Instagram</a></li>
              <li><a href="https://www.twitter.com/staydcom" target="_blank">Twitter</a></li>
              <li><a href="https://www.linkedin.com/company/staycom" target="_blank">Linkedin</a></li>
            </ul>
          </b-col>
          <b-col sm="6" lg="3">
            <h5>Legal &amp; Privacy</h5>
            <ul class="footer-list">
              <li><router-link :to="'/' + $i18n.locale + '/page/faqs'">FAQ's</router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/terms-and-conditions'">Terms &amp; Conditions</router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/privacy'">Privacy Policy </router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/cookies'">Cookie Policy </router-link></li>
            </ul>
          </b-col>
          <b-col sm="6" lg="3">
            <h5>Company</h5>
            <ul class="footer-list">
              <li><router-link :to="'/' + $i18n.locale + '/page/press'">Press</router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/jobs'">Jobs</router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/corporate-responsibility'">Corporate Responsibility</router-link></li>
              <li><router-link :to="'/' + $i18n.locale + '/page/blog'">Corporate Blog</router-link></li>
              <li><a href="https://ir.stay.com.de" target="_blank">Investor Relations</a></li>
            </ul>
          </b-col>
          <b-col sm="6" lg="3">
            <h5>Stay.com International</h5>
            <div class="network-wrap">
              <ul class="footer-list">
                <li><a href="https://www.stay.nz">stay.nz</a></li>
                <li><a href="https://www.stay.je">stay.je</a></li>
                <li><a href="https://www.stay.ac">stay.ac</a></li>
                <li><a href="https://www.stay.am">stay.am</a></li>
                <li><a href="https://www.stay.bz">stay.bz</a></li>
                <li><a href="https://www.stay.gs">stay.gs</a></li>
                <li><a href="https://www.stay.hn">stay.hn</a></li>
                <li><a href="https://www.stay.ps">stay.ps</a></li>
                <li><a href="https://www.stay.mg">stay.mg</a></li>
                <li><a href="https://www.stay.ml">stay.ml</a></li>
                <li><a href="https://www.stay.wf">stay.wf</a></li>
                <li><a href="https://www.stay.vg">stay.vg</a></li>
                <li><a href="https://www.stay.tk">stay.tk</a></li>
                <li><a href="https://www.stay.tf">stay.tf</a></li>
                <li><a href="https://www.stay.pe">stay.pe</a></li>
                <li><a href="https://www.stay.lc">stay.lc</a></li>
                <li><a href="https://www.stay.gd">stay.gd</a></li>
                <li><a href="https://www.stay.co.at">stay.co.at</a></li>
                <li><a href="https://www.stay.me.uk">stay.me.uk</a></li>
                <li><a href="https://www.stay.com.de">stay.com.de</a></li>
                <li><a href="https://www.stay.com.vc">stay.com.vc</a></li>
                <li><a href="https://www.stay.com.tw">stay.com.tw</a></li>
                <li><a href="https://www.stay.com.es">stay.com.es</a></li>
                <li><a href="https://www.stay.com.se">stay.com.se</a></li>
                <li><a href="https://www.stay.cologne">stay.cologne</a></li>
                <li><a href="https://www.stay.business">stay.business</a></li>
                <li><a href="https://www.stay.brussels">stay.brussels</a></li>
                <li><a href="https://www.stay.flights">stay.flights</a></li>
                <li><a href="https://www.stay.tours">stay.tours</a></li>
                <li><a href="https://www.stay.cruises">stay.cruises</a></li>
                <li><a href="https://www.stay.bike">stay.bike</a></li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bottom-footer">
        <b-container>
          <img class="footer-logo" alt="Stay.com" src="../../assets/logo.svg">
          <small class="copyright-text">
            Copyright 2021 Stay.com &reg; | All rights reserved
          </small>
        </b-container>
    </div>
  </footer>
</template>

<script>
import NewsletterSubscribe from '@/components/ui/NewsletterSubscribe.vue'
import SocialIconList from '@/components/ui/SocialIconList.vue'

export default {
  name: 'Footer',
  props: {
    msg: String
  },
  components: {
    NewsletterSubscribe,
    SocialIconList,
  }
}
</script>


<style scoped>
  .network-wrap{
    max-height:150px;
    overflow-y:scroll;
  }
  .network-wrap li{
    display: inline-block;
    width: 50%;
  }
  .top-newsletter{
    color:#fff;
    margin-bottom:30px;
    border-bottom:1px solid #697379;
    margin-bottom:30px;
  }
  .newsletter-text{
    margin-top:10px;
    margin-bottom:30px;
  }
  .newsletter-subscribe{
    margin-bottom:30px;
  }
  .top-footer{
    padding:30px 0;
  }
  .footer-address{
    margin-bottom:30px;
  }
  .footer-social{
    margin-bottom:30px;
  }
  .footer-list{
    list-style:none;
    color:#fff;
    padding:0;
    margin-bottom:30px;
    line-height:22px;
  }
  .footer-list a{
    color:#fff;
  }
  .bottom-footer{
    padding:30px;
    background-color:#37454D;
    color:#fff;
  }
  .footer-logo{
    width:125px;
    display:block;
    margin:0 auto;
  }
  .copyright-text{
    color:#9ba2a6;
    margin-top:15px;
    display:inline-block;
    width:100%;
    text-align:center;
    font-size:12px;
  }
  .top-footer{
    background-color:#293339;
    color:#fff;
  }
</style>
